// extracted by mini-css-extract-plugin
module.exports = {"BundleBox":"BundleBox_BundleBox__yfQum"};